<template>
  <v-dialog 
    v-if="cow"
    :value="visible" 
    @input="$emit('close')" 
    max-width="950px" >
    <v-card class="card_container">
      <v-card-title class="card_title">
        {{ cow.mesureval01 }} 상세정보
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-5">
        <datePicker
          :fr_date="fr_date" 
          :to_date="to_date" 
          @update:fr_date="updateFrDate"
          @update:to_date="updateToDate"
          @refresh="refresh" 
        />

        <div class="mt-5 mb-5 chart_content" >
          <Chart 
            chartType="Bar"
            :chartData="chartData"
            :chartOptions="Bar2LineChartOptions"
            :chartSize="chartSize" 
          />
        </div>


      <div class="table_content mt-3">
        <div class="table_layout">
          <v-data-table dense
              fixed-header
              :footer-props="{
                itemsPerPageOptions:[-1]
              }"
              :items-per-page="-1" 
              :headers="headers"
              :items="items"
              no-data-text="측정된 자료가 없습니다."
              class="table_content"
              height="50vh"
              item-key="mesuredt"
              single-select
              hide-default-footer
              :sort-by= "['mesuredt']"
              :sort-desc= "[true]"
          ></v-data-table>
        </div>
      </div>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import Chart from "@/components/chart/Chart.vue"

import datePicker from "@/components/compo/datePicker_day.vue";
import { Bar2LineChartOptions } from "@/components/chart/option.js"; 

export default {
  props: {
    visible: Boolean,
    cow: Object,
    farm: Object 
  },
  components :{
    Chart,
    datePicker
  },
  watch: {
    cow(newVal) {
      if (newVal && this.farm) {
        this.refresh();
      }
    },
    farm(newVal) {
      if (newVal && this.cow) {
        this.refresh();
      }
    },
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 7));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

    // this.chartData = this.drawChart();
  },
  data() {
    return {
      fr_date: '',
      to_date: '',

      Bar2LineChartOptions:Bar2LineChartOptions,

      headers: [
        { text: '측정시간', align:'center',sortable: true, value: 'mesuredt' },
        { text: '운동량(회/분)', align:'center',sortable: false,value: 'mesureval02' },
        { text: '반추량(회/분)', align:'center',sortable: false,value: 'mesureval03' },
        { text: '체온(℃ )', align:'center',sortable: false,value: 'mesureval04' },
        { text: 'PH', align:'center',sortable: false,value: 'mesureval05' },
        { text: '발정상태', align:'center',sortable: false, value: 'mesureval06' },
        { text: '건강상태', align:'center',sortable: false, value: 'mesureval07' },
        { text: '알람시간', align:'center',sortable: false, value: 'mesureval08' },

      ],

      items: [],
      chartData: {},
      chartSize: {
        height:'280px',
        width: '70vw',
      },
    };
  },
  methods: {
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    refresh(){
      Apis.listDiaryBI01dataOfEntity({
        "farm_cd" : this.farm.farm.code,
        "entity_no" : this.cow.mesureval01,
        "stand_date" : this.to_date,
        "days" : 7
      },(res) => {  
        if (res.result) {
        this.items = res.data.values;
        
        this.chartData = this.drawChart();
        this.$store.commit("resMessage",res.message);
      } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listDiaryBI01dataOfEntity API 호출 오류",err)
          this.loading = false;
      })
    },
    drawChart(){
      const labels = this.items.map(i => i.mesuredt.substring(5, 10));
      const activity = this.items.map(i => Number(i.mesureval02));
      const temperature = this.items.map(i => i.mesureval04 === "" ? null : Number(i.mesureval04));
      const rumination = this.items.map(i => Number(i.mesureval03));

      return {
        labels: labels,
        datasets: [
          {
            label: '운동량',
            type: 'bar',
            data: activity,
            backgroundColor: '#005B96',
            yAxisID: 'y1',
            // order:2
          },
          {
            label: '체온 (°C)',
            type: 'line',
            data: temperature,
            borderColor: '#ADC0F6',
            backgroundColor: 'rgba(173, 192, 246)',
            yAxisID: 'y2',
            fill: false,
            // order:1
          },
          {
            label: '반추시간 (분)',
            type: 'line',
            data: rumination,
            borderColor: '#80BCBD',
            backgroundColor: 'rgba(128, 188, 189)',
            yAxisID: 'y1',
            fill: false,
          }
        ]
      }
    }
  }
};

</script>


<style lang="scss" scoped>
@import '../../../style/base.scss';

.card_container{
  border-radius: 20px;
}
.card_title{
  background-color: $main-color;
  color:white;
  border-radius: 0 20px 0 0;
}
.chart_content{
  width:80%;
  margin:0 auto;
}
.table_content{
  height:40vh;
  min-height:250px;
}

.table_layout{
  margin-top:10px;
  padding:0 !important;
}
</style>